import { render, staticRenderFns } from "./ExamPoint.vue?vue&type=template&id=fbcbded0&scoped=true&"
import script from "./ExamPoint.vue?vue&type=script&lang=js&"
export * from "./ExamPoint.vue?vue&type=script&lang=js&"
import style0 from "./ExamPoint.vue?vue&type=style&index=0&id=fbcbded0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbcbded0",
  null
  
)

export default component.exports